// ============================================================
// permission.js
// ------------------------------------------------------------
// อ่านสิทธิ์ผู้ใช้ (role_detail ใน localStorage) เพื่อซ่อน/แสดงปุ่มในแต่ละหน้า
//
// รูปแบบข้อมูลที่เก็บไว้ (ตั้งตอนล็อกอิน):
//   [{ name: "customer", role: [1,1,0,0,1,0] }, ...]
// ตำแหน่งใน array คือสิทธิ์ตามลำดับ view, create, update, delete, download, upload (1 = มีสิทธิ์)
//
// เดิมทุกหน้าเขียนเองว่า getStorage("role_detail")?.find(i => i.name === "xxx")?.role[1] === 1
// ซึ่งพังง่ายถ้าลำดับ index เปลี่ยน — ย้ายมารวมที่นี่แล้วเรียกด้วยชื่อสิทธิ์แทนตัวเลข
// ============================================================

import { getStorage } from "./storage.js";

// ลำดับสิทธิ์ใน array role (ต้องตรงกับที่ backend ส่งมาและที่หน้า Login แปลงไว้)
export const PERMISSION_ORDER = ["view", "create", "update", "delete", "download", "upload"];

// สิทธิ์ทั้งชุดของเมนูหนึ่ง เช่น getRole("customer") → [1,1,0,0,1,0]
// คืน [] ถ้าไม่มีสิทธิ์เมนูนั้นเลย (ทำให้ role[n] เป็น undefined = ไม่มีสิทธิ์)
export const getRole = (menu_name) => getStorage("role_detail")?.find((item) => item.name === menu_name)?.role || [];

// เช็คสิทธิ์รายตัว เช่น can("customer", "create")
export const can = (menu_name, action) => getRole(menu_name)[PERMISSION_ORDER.indexOf(action)] === 1;

// สิทธิ์ทั้งชุดในรูป object อ่านง่าย เช่น const p = permission("customer"); if (p.create) ...
export const permission = (menu_name) => {
  const role = getRole(menu_name);
  const result = {};
  PERMISSION_ORDER.forEach((action, index) => {
    result[action] = role[index] === 1;
  });
  return result;
};

// แปลง role_detail ที่ backend ส่งมาตอนล็อกอิน ให้เป็นรูปที่ระบบเก็บใน localStorage
// backend ส่ง permission เป็นสตริง "true"/"false" → แปลงเป็น 1/0 ตามลำดับ PERMISSION_ORDER
export const mapRoleDetail = (role_detail = []) =>
  role_detail.map((r) => ({
    name: r.menu_name,
    role: PERMISSION_ORDER.map((action) => (r.permission[action] === "true" ? 1 : 0)),
  }));
